import { render, staticRenderFns } from "./ProductsBlock.vue?vue&type=template&id=91b7af3a&scoped=true"
import script from "./ProductsBlock.vue?vue&type=script&lang=js"
export * from "./ProductsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91b7af3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91b7af3a')) {
      api.createRecord('91b7af3a', component.options)
    } else {
      api.reload('91b7af3a', component.options)
    }
    module.hot.accept("./ProductsBlock.vue?vue&type=template&id=91b7af3a&scoped=true", function () {
      api.rerender('91b7af3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/ProductsBlock.vue"
export default component.exports